import { E_Network } from '@/ts/enums/E_Network';

const DEFAULT_NETWORK = E_Network.SEPOLIA;

const isNetwork = (value?: string): value is E_Network =>
  Object.values(E_Network).some(network => network === value);

export const getActiveNetwork = (): E_Network => {
  const envNetwork = process.env.NEXT_PUBLIC_NETWORK;
  if (isNetwork(envNetwork)) {
    return envNetwork;
  }

  return DEFAULT_NETWORK;
};
